import Image from 'next/image';
import Link from 'next/link';

import classes from '../../index.module.css';
import { QuickServiceCellProps } from './models';

export const QuickServiceCell = ({ title, href, imageUrl, index }: QuickServiceCellProps) => {
    return (
        <Link
            href={href}
            style={{ animationDelay: `${70 + index * 40}ms` }}
            className={`${classes.cell} group flex cursor-pointer flex-col items-center gap-2 rounded-lg px-1 py-2 text-center no-underline
                transition-transform duration-200 ease-out hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2
                focus-visible:ring-primary/40 active:scale-[0.97] motion-reduce:transition-none motion-reduce:hover:translate-y-0
                motion-reduce:active:scale-100`}>
            <span
                className={`${classes.well} relative flex h-14 w-14 items-center justify-center overflow-hidden rounded-lg bg-white ring-1 ring-N200
                    transition-transform duration-200 ease-out group-hover:scale-105 group-hover:ring-primary/30 md:h-16 md:w-16`}>
                {imageUrl ? (
                    <Image
                        src={imageUrl}
                        alt=''
                        width={44}
                        height={44}
                        className='h-10 w-10 object-contain transition-transform duration-200 ease-out group-hover:scale-110 md:h-11 md:w-11'
                    />
                ) : (
                    <span className='h-10 w-10 rounded-lg bg-N100 md:h-11 md:w-11' aria-hidden />
                )}
            </span>
            <span
                className='line-clamp-2 w-full text-[11px] font-medium leading-4 text-blackHighEmphasis transition-colors duration-200
                    group-hover:text-primary md:text-xs md:leading-5'>
                {title}
            </span>
        </Link>
    );
};
